import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button, Form, Row, Col, ResponsiveEmbed, Breadcrumb } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
const configData = require( './../../config.json');

const ToyotaConfigurationForm = () => {
    const initialFormData = {
        organizationName: '',
        org_id: '',  
        onedriveClientId: '',
        onedriveClientSecret: '',
        onedriveRedirectUri: '',
        onedriveRefreshToken: '',
        onedriveUploadPath: '',
        emailHost: '',
        email: '',
        emailPassword: '',
        emailSubjectFilter: '',
        emailImapProtocol: '',
        emailSmtpHost: '',
        emailSmtpPort: '',
        directoryLog: '',
        incomingDirectory: '',
        mongoConnectionString: '',
        mongoUploadDatabaseName: '',
        mongoConfigurationDatabaseName: ''
    };
    
    const [organizations, setOrganizations] = useState([]);
    

    useEffect(() => {
        const fetchData = async () => {
            try {
                await Promise.all([
                    fetchOrganizations(),
                    // fetchFileTypes(),
                    // fetchGroupEmails()
                ]);
            } catch (error) {
                console.error('Error fetching data:', error);
            } 
        };
        fetchData();
    }, []); // Fetch dependencies only once

    const fetchOrganizations = async () => {
        
        var userorgid= localStorage.getItem("userorgid");
        const orgShortName= (JSON.parse( localStorage.getItem("session"))).Result[0].org;
        
        // toast.error("userorgid: "+ userorgid);
        setOrganizations([{"_id":userorgid, "name":orgShortName}]);
        // This is code to get all organizations

        /*
        try {
            axios.get(configData.SERVER_URL+`fincorp_getOrganization`)
            .then((response) => 
            {
                // toast.error(JSON.stringify(response.data, null, 2));
                setOrganizations(response.data)

            });
            
        } catch (error) {
            console.error('Error fetching organizations:', error);
            toast.error('Failed to fetch organizations.');
        }*/
    };

    const fetchOrganizationData = async (organization_id, org_name) => {
        try {
            const response = await axios.get(configData.FILEVALIDATION_URL+"getOrganizationConfigData", 
            {params : {org: organization_id}}
            )
             
            
            
            if(response.data !== ""){
                setFormData({
                    organizationName: response.data["Organization Name"],
                    org_id: organization_id,
                    onedriveClientId: response.data["OneDrive"]["onedrive.client-id"],
                    onedriveClientSecret: response.data["OneDrive"]["onedrive.client-secret"],
                    onedriveRedirectUri: response.data["OneDrive"]["onedrive.redirect-uri"],
                    onedriveRefreshToken: response.data["OneDrive"]["onedrive.refresh-token"],
                    onedriveUploadPath: response.data["OneDrive"]["onedrive.upload-path"],
                    emailHost: response.data["Email"]["Host"],
                    email: response.data["Email"]["Email"],
                    emailPassword: response.data["Email"]["Password"],
                    emailSubjectFilter: response.data["Email"]["SubjectFilter"],
                    emailImapProtocol: response.data["Email"]["ImapProtocol"],
                    emailSmtpHost: response.data["Email"]["SmtpHost"],
                    emailSmtpPort: response.data["Email"]["SmtpPort"],
                });
            }else{
                setFormData({
                    organizationName: org_name,
                    org_id: organization_id,
                    onedriveClientId: "",
                    onedriveClientSecret: "",
                    onedriveRedirectUri: "",
                    onedriveRefreshToken: "",
                    onedriveUploadPath: "",
                    emailHost: "",
                    email: "",
                    emailPassword: "",
                    emailSubjectFilter: "",
                    emailImapProtocol: "",
                    emailSmtpHost: "",
                    emailSmtpPort: "",
                });
            }
            
            
                
            // setOrganizations(res.data);
            
        } catch (error) {
            console.error('Error fetching organizations:', error);
            toast.error('Failed to fetch organizations.');
        }
    };

    const [formData, setFormData] = useState(initialFormData);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if(name === 'organizationName'){
            
            const selectedOrg = organizations.find((org) => org.name === value);
            
                // toast.error("Selected ID:"+  selectedOrg._id);
                // toast.error("Selected Name:"+ selectedOrg.name);
            fetchOrganizationData(selectedOrg._id, selectedOrg.name);
              
            
        }else{
            setFormData({
                ...formData,
                [name]: value,
            });
        }
        
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(configData.FILEVALIDATION_URL+'organization-configuration', formData);
            toast.success('Configuration saved successfully!');
            setFormData(initialFormData); // Clear the form
        } catch (error) {
            console.error('Error saving configuration', error);
            toast.error('Failed to save configuration. Please try again.');
        }
    };

    return (
        <div className="container lookuplimits-container">
            <Form  >
                
                <div className="centeralign mb-3">
                    <span className='mainheadings' >
                        Organization Configuration Form
                    </span> 
                </div>

                <div className="centeralign">
                    <Form.Label className="required">
                        Organization Name: 
                    

                
                    </Form.Label>{" "}
                    <select className="form-control-2" name= "organizationName" value={formData.organizationName} onChange={handleChange}>
                        <option value="">Select an Organization</option>
                        {organizations.map((org) => (
                            <option key={org.name} value={org.name}>
                                {org.name}
                            </option>
                        ))}
                    </select>
                </div>

                <Form.Row>
                    <Row className = "margin-t10 col-md-12">
                        <Col md = {6} className="row">
                            <Col md ={4}>
                                <Form.Label className = "required">
                                    OneDrive Client ID:
                                </Form.Label>
                            </Col>
                            <Col>
                                <Form.Control 
                                    type= "text"
                                    name="onedriveClientId" 
                                    value={formData.onedriveClientId} 
                                    onChange={handleChange}
                                />
                            </Col>
                        </Col>
                        <Col md = {6} className="row">
                            <Col md ={4}>
                                <Form.Label className = "required">
                                    Email Host:
                                </Form.Label>
                            </Col>
                            <Col>
                                <Form.Control 
                                    type="text" 
                                    name="emailHost" 
                                    value={formData.emailHost} 
                                    onChange={handleChange}
                                />
                            </Col>
                        </Col>
                    </Row>
                </Form.Row>

                <Form.Row>
                    <Row className = "margin-t10 col-md-12">
                        <Col md = {6} className="row">
                            <Col md ={4}>
                                <Form.Label className = "required">
                                    OneDrive Client Secret:
                                </Form.Label>
                            </Col>
                            <Col>
                                <Form.Control 
                                    type="text"  
                                    name="onedriveClientSecret" 
                                    value={formData.onedriveClientSecret} 
                                    onChange={handleChange}
                                />
                            </Col>
                        </Col>
                        <Col md = {6} className="row">
                            <Col md ={4}>
                                <Form.Label className = "required">
                                    Email:
                                </Form.Label>
                            </Col>
                            <Col>
                                <Form.Control 
                                    type="email"
                                    name="email" 
                                    value={formData.email} 
                                    onChange={handleChange}
                                />
                            </Col>
                        </Col>
                    </Row>
                </Form.Row>

                <Form.Row>
                    <Row className = "margin-t10 col-md-12">
                        <Col md = {6} className="row">
                            <Col md ={4}>
                                <Form.Label className = "required">
                                    OneDrive Redirect URI:
                                </Form.Label>
                            </Col>
                            <Col>
                                <Form.Control 
                                    type="text"  
                                    name="onedriveRedirectUri" 
                                    value={formData.onedriveRedirectUri} 
                                    onChange={handleChange}
                                />
                            </Col>
                        </Col>
                        <Col md = {6} className="row">
                            <Col md ={4}>
                                <Form.Label className = "required">
                                    Email Password:
                                </Form.Label>
                            </Col>
                            <Col>
                                <Form.Control 
                                    type="password"
                                    name="emailPassword" 
                                    value={formData.emailPassword} 
                                    onChange={handleChange}
                                />
                            </Col>
                        </Col>
                    </Row>
                </Form.Row>

                <Form.Row>
                    <Row className = "margin-t10 col-md-12">
                        <Col md = {6} className="row">
                            <Col md ={4}>
                                <Form.Label className = "required">
                                    OneDrive Refresh Token:
                                </Form.Label>
                            </Col>
                            <Col>
                                <Form.Control 
                                    type="text"  
                                    name="onedriveRefreshToken" 
                                    value={formData.onedriveRefreshToken} 
                                    onChange={handleChange}
                                />
                            </Col>
                        </Col>
                        <Col md = {6} className="row">
                            <Col md ={4}>
                                <Form.Label className = "required">
                                    Email Subject Filter:
                                </Form.Label>
                            </Col>
                            <Col>
                                <Form.Control 
                                    type="text" 
                                    name="emailSubjectFilter" 
                                    value={formData.emailSubjectFilter} 
                                    onChange={handleChange}
                                />
                            </Col>
                        </Col>
                    </Row>
                </Form.Row>

                <Form.Row>
                    <Row className = "margin-t10 col-md-12">
                        <Col md = {6} className="row">
                            <Col md ={4}>
                                <Form.Label className = "required">
                                    OneDrive Upload Path:
                                </Form.Label>
                            </Col>
                            <Col>
                                <Form.Control 
                                    type="text" 
                                    name="onedriveUploadPath" 
                                    value={formData.onedriveUploadPath} 
                                    onChange={handleChange}
                                />
                            </Col>
                        </Col>
                        <Col md = {6} className="row">
                            <Col md ={4}>
                                <Form.Label className = "required">
                                    Email IMAP Protocol:
                                </Form.Label>
                            </Col>
                            <Col>
                                <Form.Control 
                                    type="text" 
                                    name="emailImapProtocol" 
                                    value={formData.emailImapProtocol} 
                                    onChange={handleChange}
                                />
                            </Col>
                        </Col>
                    </Row>
                </Form.Row>

                <Form.Row>
                    <Row className = "margin-t10 col-md-12">
                        <Col md = {6} className="row">
                            <Col md ={4}>
                                <Form.Label >
                                   
                                </Form.Label>
                            </Col>
                            <Col>
                                
                            </Col>
                        </Col>
                        <Col md = {6} className="row">
                            <Col md ={4}>
                                <Form.Label className = "required">
                                    Email SMTP Host:
                                </Form.Label>
                            </Col>
                            <Col>
                                <Form.Control 
                                    type="text" 
                                    name="emailSmtpHost" 
                                    value={formData.emailSmtpHost} 
                                    onChange={handleChange}
                                />
                            </Col>
                        </Col>
                    </Row>
                </Form.Row>

                <Form.Row>
                    <Row className = "margin-t10 col-md-12">
                        <Col md = {6} className="row">
                            <Col md ={4}>
                                <Form.Label>
                                   
                                </Form.Label>
                            </Col>
                            <Col>
                                
                            </Col>
                        </Col>
                        <Col md = {6} className="row">
                            <Col md ={4}>
                                <Form.Label className = "required">
                                    Email SMTP Port:
                                </Form.Label>
                            </Col>
                            <Col>
                                <Form.Control 
                                    type="text" 
                                    name="emailSmtpPort" 
                                    value={formData.emailSmtpPort} 
                                    onChange={handleChange}
                                />
                            </Col>
                        </Col>
                    </Row>
                </Form.Row>

                <div className="float-right mt-10 mr-9p"> 

                    <Button type="submit" variant="primary" onClick={handleSubmit}>
                        Save
                    </Button>
                    <Button type="button" variant="secondary" className="ml-10" onClick={() => setFormData(initialFormData)}>
                         Clear
                    </Button>
                </div>
            </Form>
        </div>
        

    );
};

export default ToyotaConfigurationForm;
